export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';
export const SELECTED_CATERGORY = 'SELECTED_CATERGORY';
export const GET_ALL_QUIZZESS_OF_SELECTED_CATEGORY = 'GET_ALL_QUIZZESS_OF_SELECTED_CATEGORY';
export const ADD_SELECTED_QUIZ_QUESTIONS = 'ADD_SELECTED_QUIZ_QUESTIONS';
export const INCREASE_POINTER_OF_QUESTION = 'INCREASE_POINTER_OF_QUESTIONS';
export const UPDATE_TOTAL_SCORE = 'UPDATE_TOTAL_SCORE';
export const SET_LOGGED_IN_USER_DETAILS = 'SET_LOGGED_IN_USER_DETAILS';
export const UPDATE_USER_SCORE = 'UPDATE_USER_SCORE';